/* eslint-env browser */

/**
 * Light/Dark Mode Toggle
 */

(function (window, document) {
  $(".theme-toggle").on("click", function () {
    toggleTheme();
  });
})(window, document);

// function to set a given theme/color-scheme
function setTheme(themeName) {
  localStorage.setItem("theme", themeName);
  document.documentElement.className = themeName;
  // updateCommentPlugInTheme(themeName);
  updateFluidboxTheme(themeName);
}

// function to update theme/color-scheme in FB comment plugin
// function updateCommentPlugInTheme(themeName) {
//   var comments = document.getElementsByClassName("fb-comments");
//   for (var index = 0; index < comments.length; index++) {
//     comments[index].setAttribute(
//       "data-colorscheme",
//       themeName.replace("theme-", "")
//     );
//   }
//   FB.XFBML.parse();
// }

// function to update fluidbox background color by current theme
function updateFluidboxTheme(themeName) {
  console.log("theme", themeName);
  window.fluidboxGhostConfig = {
    theme:
      themeName === "theme-dark"
        ? "hsla(0, 0%, 13%, 1)"
        : "hsla(0, 100%, 100%, 1)",
    showCaption: false,
  };
}

// function to toggle between light and dark theme
function toggleTheme() {
  if (localStorage.getItem("theme") === "theme-dark") {
    setTheme("theme-light");
  } else {
    setTheme("theme-dark");
  }
}
// Immediately invoked function to set the theme on initial load
(function () {
  if (localStorage.getItem("theme") === "theme-dark") {
    setTheme("theme-dark");
  } else {
    setTheme("theme-light");
  }
})();
